import { Box } from "@mui/material";
import Head from "next/head";
import Breadcrumbs from "../src/components/common/Breadcrumbs";
import LoanFormPopupV2 from "../src/Drawer/LoanFormPopupV2";
import { MemoizedCityPopup } from "../src/Popups/cityPopup/cityPopup";
import { productCarouselSchema } from "../src/constants/carouselSchema";
import { newVehicles, vehicles } from "../src/constants/vehicleData";
import { MemoizedFooter } from "../src/layouts/footer";
import { MemoizedHeader } from "../src/layouts/header";
import StoryDrawer from "../src/modules/Finance/storyDrawer";
import BookVehicleDrawer from "../src/modules/Home/Drawer/bookVehicleDrawer";
import QlDrawerComponent from "../src/modules/LeadDataCollection/DrawerComponents/LoanDrawerComponents";
import EmiMain from "../src/pages/emi/EmiMain";

const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Finance" },
];

const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Finance",
      item: "https://www.turno.club/finance",
    },
  ],
};

const emi = ({ allvehicles }) => {
  return (
    <>
      <Head>
        <title>
          Get the lowest cost EV financing with Turno. Paperless process
        </title>
        <meta
          name="description"
          content="Best EV financing, Electric auto finance, Electric Vehicle Finance"
        />
        <meta
          name="keywords"
          content="Turno finance, three wheeler finance, electric vehicle loan, ev loan interest rate, electric vehicle loan, ev loan, vehicle loan finance, EV commercial loan, commercial vehicle loan interest rate"
        />
        <meta name="author" content="Turno" />
        <meta name="url" content="https://www.turno.club/finance" />

        <meta name="robots" content="INDEX,ARCHIVE,FOLLOW" />
        <meta name="lang" content="en" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Facebook */}
        <meta property="og:url" content="https://www.turno.club/finance" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Get the lowest cost EV financing with Turno. Paperless process"
        />
        <meta
          property="og:description"
          content="Best EV financing, Electric auto finance, Electric Vehicle Finance"
        />
        <meta property="og:image" content="/logoIcon.png" />
        <meta property="fb:app_id" content="5796260583761767" />
        <meta property="fb:pages" content="646488286564232" />
        {/* Twitter */}
        <meta
          name="twitter:description"
          content="Best EV financing, Electric auto finance, Electric Vehicle Finance."
        />
        <meta
          name="twitter:title"
          content="Get the lowest cost EV financing with Turno. Paperless process"
        />
        <meta name="twitter:site" content="@Turno" />
        <meta name="twitter:creator" content="@Turno" />
        <meta name="twitter:url" content="https://www.turno.club/finance" />
        <meta
          name="twitter:app:id:googleplay"
          content="com.customerapp.turno.turno_customer_application"
        />
        <meta name="twitter:app:country" content="IN" />

        <link rel="canonical" href="https://www.turno.club/finance" />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(productCarouselSchema),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(BREADCRUMB_SCHEMA),
          }}
          defer
        />
      </Head>
      <Box>
        {/* <MemoizedHeader /> */}
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <MemoizedHeader />
        </Box>

        {/* <MemoizedSearchHeader hideSearchHeader={true}/> */}
        <MemoizedCityPopup />
        <StoryDrawer />
        <BookVehicleDrawer />
        <LoanFormPopupV2 />
        <QlDrawerComponent />
        <EmiMain vehiclesData={allvehicles} />
        <Box sx={{ width: { xs: "100%", md: "84%" }, margin: "20px auto", padding: { xs: "0 12px", md: "0" } }}>
          <Breadcrumbs items={BREADCRUMB_ITEMS} />
        </Box>
        <MemoizedFooter />
      </Box>
    </>
  );
};

export default emi;

export const getStaticProps = (context) => {
  let allvehicles = [...vehicles, ...newVehicles];

  return {
    props: { allvehicles },
  };
};
